<div class="row">
    <div class="col ml-2">
        <div class="card-body  widget-body pt-2">
              <div class="row mt-2"  *ngIf="!ToMonitor.isView">
                <div class="col-lg-12">
                  <button class="btn blue-btn btn-sm mb-1" type="button"  data-bs-target="#monitormodal" data-bs-toggle="modal"   (click)="getAgencyMonitorListdropdown()"
                  >Assign Monitor List</button>
                    <input type="radio" class="ml-5" name="all" value="Active" *ngIf="!ToMonitor.isView"
                        [(ngModel)]="Status" (change)="getStatusLov()"> &nbsp;Active
                    <input type="radio" class="ml-3" name="all" value="InActive" *ngIf="!ToMonitor.isView"
                        [(ngModel)]="Status" (change)="getStatusLov()"> &nbsp; InActive
                        <input type="radio" class="ml-3" name="all" value="All" *ngIf="!ToMonitor.isView"
                        [(ngModel)]="Status" (change)="getStatusLov()"> &nbsp; All
              </div>
            </div>
          <div class="row mt-3">
            <div class="col-lg-12">
                <ejs-grid #grid [dataSource]='data| async' [allowResizing]='true' [allowSorting]='true' [allowFiltering]='true'
                    [filterSettings]='filterOptions' allowPaging='true' [allowSorting]='true' [pageSettings]='initialPage'
                    allowTextWrap='true' [textWrapSettings]='wrapSettings' [showColumnChooser]='true'
                    (dataStateChange)='dataStateChangeNotes($event)' (resizeStop)="onResizeNotes($event)"
                    (actionBegin)="onActionCompleteNotes($event)">
                    <e-columns>
                        <e-column minWidth=50 headerText="Actions" uid="action">
                            <ng-template #template let-data>
                                <button class="btn btn-edit-table "  style="margin-right: 2px;"
                                    (click)="editmonitorlist(data);" [disabled]="ToMonitor.isView"  ><i
                                        class="fa fa-edit"></i></button>
                                <button class="btn btn-delete-table " (click)="deletemonitor(data.id)" [disabled]="ToMonitor.isView"><i
                                        class="fa fa-trash"></i></button>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="monitorName" headerText="Monitor Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="notes" headerText="Notes" type="string" >
                          <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                      </e-column>
                      <e-column minWidth=50 field="statusName" headerText="Status" type="string"  [allowSorting]='false' [allowFiltering]='false'>
                        <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                    </e-column>
                     
                    <e-column minWidth=50 field="monitorDate" headerText="MonitorDate" type="date" 
                    [format]='formatOptions' [allowSorting]='false' [allowFiltering]='false'>
                        <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                    </e-column>

                    <e-column minWidth=50 field="inActiveDate" headerText="Inactive Date" type="date" 
                    [format]='formatOptions' [allowSorting]='false' [allowFiltering]='false'>
                        <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                    </e-column>
                     
                    </e-columns>
                </ejs-grid>
                <div *ngIf="monitordetailsList?.length == 0" class="text-center" style="color:red">
                    <p>No data available</p>
                </div>
            </div>
        </div>
        </div>
      </div>
     </div>
  <!-- ////////////////////////////////Create and Update Monitor List/////////////////////////////////// -->
  <span id="openMonitorModal1" data-bs-target="#monitormodal" data-bs-toggle="modal"></span>
  <div class="modal fade modalbackgrod" id="monitormodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="monitorListbo.id =='00000000-0000-0000-0000-000000000000'"> Assign Monitor
              List</span> <span *ngIf="monitorListbo.id !='00000000-0000-0000-0000-000000000000'">Update Monitor
              List</span> </h5>
          <button type="button" class="btn-close"  aria-label="Close"  (click)="closemodal()"  data-bs-dismiss="modal"  >
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-5">
              <label>Monitor List
              </label><sup class="super-script">*</sup>
            </div>
            <div class="col-lg-7">
              

              <ng-select [items]="monitorList" bindLabel="label" bindValue="monitorId"   [(ngModel)]="monitorListbo.monitorId"
              placeholder="Select color" (ngModelChange)="ChangeColornotes()">
              <ng-template ng-label-tmp let-item="item" >
                  <i  class="fa fa-circle" [ngStyle]="{'color': item.colorCode != null  ? item.colorCode  : (item.value != null ? item.value : '#f2f6f5') }"></i> {{ item.colorandnotes }}
              </ng-template>

              <ng-template ng-option-tmp let-item="item" >
                  <i class="fa fa-circle" [ngStyle]="{'color': item.colorCode != null  ? item.colorCode  : (item.value != null ? item.value : '#f2f6f5') }"></i> {{ item.colorandnotes }}
              </ng-template>
          </ng-select>

            </div>
          </div>
            <div class="row mt-3">
              <div class="col-lg-5">
                <label>Notes
                </label><sup class="super-script">*</sup>
              </div>
              <div class="col-lg-7">
                <textarea type="text" class="form-control" 
                  [(ngModel)]="monitorListbo.notes"></textarea>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-5">
                <label>Status
                </label><sup class="super-script">*</sup>
              </div>
              <div class="col-lg-7">
                  <ng-select  [clearable]="true" [searchable]="true"  [items]="statusList"  
               bindLabel="lovName"
                  bindValue="id"  [(ngModel)]="monitorListbo.statusLid" (ngModelChange)="monitorstatusListChange()" >
                </ng-select>
              </div>
            </div>
            <div class="row mt-3">
                <div class="col-lg-5">
                  <label>Monitor Date
                  </label><sup class="super-script">*</sup>
                </div>
                <div class="col-lg-7">
                    <my-date-picker  [options]="myDatePickerOptions"
                    [selDate]="monitorListbo.monitorDate" placeholder="mm/dd/yyyy"
                    (inputFieldChanged)="newdates($event,'inputchage','date')"
                    (dateChanged)="newdates($event,'datechagned','date')">
        
                </my-date-picker>
                </div>
              </div>

              <div class="row mt-3" >
                <div class="col-lg-5">
                  <label>Inactive Date
                  </label>
                </div>
                <div class="col-lg-7">
                    <my-date-picker [disabled]="Inactive!='INACTIVE'" [options]="myDatePickerOptions"
                    [selDate]="monitorListbo.inActiveDate" placeholder="mm/dd/yyyy"
                    (inputFieldChanged)="newdates($event,'inputchage','inactivedate')"
                    (dateChanged)="newdates($event,'datechagned','inactivedate')">
        
                </my-date-picker>
                </div>
              </div>

          
        </div>
        <div class="modal-footer">
          <button class="btn blue-btn btn-sm" (click)="SaveOrUpdateMonitor();" [disabled]="monitorListbo.monitorId==null||monitorListbo.monitorId=='00000000-0000-0000-0000-000000000000'||monitorListbo.monitorId==undefined ||monitorListbo.notes==null||monitorListbo.notes==undefined||monitorListbo.notes==''
          ||monitorListbo.statusLid==null||monitorListbo.statusLid=='00000000-0000-0000-0000-000000000000'||monitorListbo.statusLid==undefined"><span
              *ngIf="monitorListbo.id =='00000000-0000-0000-0000-000000000000'"> Assign &
              Close</span> <span *ngIf="monitorListbo.id!='00000000-0000-0000-0000-000000000000'"  [disabled]="monitorListbo.monitorId==null||monitorListbo.monitorId=='00000000-0000-0000-0000-000000000000'||monitorListbo.monitorId==undefined ||monitorListbo.notes==null||monitorListbo.notes==undefined||monitorListbo.notes==''
              ||monitorListbo.statusLid==null||monitorListbo.statusLid=='00000000-0000-0000-0000-000000000000'||monitorListbo.statusLid==undefined">Update & Close</span> </button>
          <button type="button" class="btn blue-btn btn-sm" (click)="closemodal()" data-bs-dismiss="modal"  >Close</button>
        </div>
      </div>
    </div>
  </div>
  
  
  
  <span id="OpendeleteModal22" data-bs-target="#deletemodaldata1" data-bs-toggle="modal"></span>
  <div class="modal fade" id="deletemodaldata1" data-bs-backdrop="static">
      <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title font-header">Delete Record</h5>
                  <button type="button" class="close" (click)="closeDelMonitorModal()"  aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body">
                  <div class="row">
                      <div class="col-lg-12">
                          <label>Do you want to delete this record ?</label>
                      </div>
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn blue-btn btn-sm" (click)="deletemonitorlist()">Delete</button>
                  <button type="button" class="btn blue-btn btn-sm"  (click)="closeDelMonitorModal()" >Cancel</button>
              </div>
          </div>
      </div>
  </div>
  